import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { fetchPreviousMessageHistoryHtml as requestFn } from '../clients/fetchPreviousMessageHistoryHtml';
import { FETCH_PREVIOUS_MESSAGE_HISTORY as actionTypes } from '../constants/asyncActionTypes';
export const fetchThreaddHistory = createAsyncAction({
  requestFn,
  actionTypes,
  toRecordFn: html => html
});